import apiSlice from "./apiSlice";
const keyIssueSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addKeyRisk: builder.mutation({
      query: (body) => ({
        url: `risk`,
        method: "POST",
        body,
      }),
    }),
    editKeyRisk: builder.mutation({
      query: ({ id, body }) => ({
        url: `/risk/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteKeyRisk: builder.mutation({
      query: (id, body) => ({
        url: `Risk/${id}`,
        method: "DELETE",
        body,
      }),
    }),
    getPendingIssue: builder.query({
      query: (req) => ({
        url: `issues/pending`,
        params: req,
      }),
    }),
    getSubmittedByMeIssue: builder.query({
      query: (req) => ({
        url: `issues/GetSubmittedIssues`,
        params: req,
      }),
    }),
    approveKeyRisk: builder.mutation({
      query: ({ id }) => ({
        url: `/Risk/${id}/approve`,
        method: "POST",
      }),
    }),
    rejectKeyRisk: builder.mutation({
      query: ({ id, body }) => ({
        url: `/Risk/${id}/reject`,
        method: "POST",
        body,
      }),
    }),
    getKeyRisk: builder.query({
      query: (req) => ({
        url: `risk/${req}`,
      }),
    }),
    updateWorkflowKeyRisk: builder.mutation({
      query: (body) => ({
        url: `/risk/UpdateWorkFlow`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useAddKeyRiskMutation,
  useEditKeyRiskMutation,
  useDeleteKeyRiskMutation,
  useGetPendingIssueQuery,
  useGetSubmittedByMeIssueQuery,
  useApproveKeyRiskMutation,
  useRejectKeyRiskMutation,
  useGetKeyRiskQuery,
  useUpdateWorkflowKeyRiskMutation
} = keyIssueSlice;
